import Lenis from 'lenis';
import $ from 'jquery';
import { gsapSingleton, scrollTriggerSingleton } from "../gsap";
const gsap = gsapSingleton();
const ScrollTrigger = scrollTriggerSingleton();

let lenisInstance; // Aggiungi questa variabile

$( document ).ready(function() {
    // Initialize a new Lenis instance for smooth scrolling
    lenisInstance = new Lenis({
        anchors: true,
        allowNestedScroll: true,
    });
    
    // Synchronize Lenis scrolling with GSAP's ScrollTrigger plugin
    lenisInstance.on('scroll', ScrollTrigger.update);
    
    gsap.ticker.add((time) => {
      lenisInstance.raf(time * 1000);
    });
    
    gsap.ticker.lagSmoothing(0);
});

export { lenisInstance }; // Esporta l'istanza